import { Suspense, lazy } from "react";

// Loaded on demand: the page uses the platform's own page parts, which the
// package entry must not pull in.
const Page = lazy(() => import("./SecurityCheck").then((m) => ({ default: m.SecurityCheck })));

export const SecurityCheckRoute = (props) => (
  <Suspense fallback={null}>
    <Page {...props} />
  </Suspense>
);

SecurityCheckRoute.title = "Second step";
SecurityCheckRoute.path = "/security-check";
SecurityCheckRoute.exact = true;

const Review = lazy(() => import("./AccessReview").then((m) => ({ default: m.AccessReview })));

export const AccessReviewRoute = (props) => (
  <Suspense fallback={null}>
    <Review {...props} />
  </Suspense>
);

// A tab of the Organization page, beside Members: what each of them can
// reach.
export const accessTab = {
  key: "access",
  label: "Access",
  path: "/access",
  component: AccessReviewRoute,
  when: "admin",
  after: "policies",
};
